<template>
  <div class="home">
    <hero-section />
    <logos-banner />
    <services-section />
    <quality-section />
    <become-client-section />
    <partners-section />
    <clients-section />
    <case-study-section />
    <what-we-offer-section />
    <faq-section />
    <cta-section />
  </div>
</template>

<script>
import HeroSection from '@/components/1.HeroSection.vue'
import LogosBanner from '@/components/2.LogosBanner.vue'
import QualitySection from '@/components/4.QualitySection.vue'
import ServicesSection from '@/components/3.ServicesSection.vue'
import BecomeClientSection from '@/components/5.BecomeClientSection.vue'
import PartnersSection from '@/components/6.PartnersSection.vue'
import ClientsSection from '@/components/7.ClientsSection.vue'
import CaseStudySection from '@/components/8.CaseStudySection.vue'
import WhatWeOfferSection from '@/components/9.WhatWeOfferSection.vue'
import FaqSection from '@/components/10.FaqSection.vue'
import CtaSection from '@/components/11.CtaSection.vue'

export default {
  name: 'HomeView',
  components: {
    HeroSection,
    LogosBanner,
    QualitySection,
    ServicesSection,
    BecomeClientSection,
    PartnersSection,
    ClientsSection,
    CaseStudySection,
    WhatWeOfferSection,
    FaqSection,
    CtaSection
  }
}
</script>

<style scoped>
.home {
  width: 100%;
}
</style>
